import { isChatFeatureEnv } from "./helper";

export const CHAT_COMPONENTS = {
  CREATE_CHAT: "CREATE_CHAT",
  CHAT_WORKSPACE: "CHAT_WORKSPACE",
};

export const CONTEXT_TYPES = {
  SHIPMENT: "SHIPMENT",
  CONTAINER: "CONTAINER",
};

export const VIEW_MODES = {
  LIST: "LIST",
  WORKSPACE: "WORKSPACE",
  PAGE: "PAGE",
  MODAL: "MODAL",
};

export const SHOW_CHAT_APP = isChatFeatureEnv() ? true : false
